export default __webpack_public_path__ + "static/media/crosst.0a88cfd0.svg";